import React from "react";
import { APP_BASE_PATH } from "../appConfig";
import { Box, Link } from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";

export const DownloadItemNode = (props) => {
  const href = `${APP_BASE_PATH}/Instruction/${props.instructionKey}/Artifact/?id=${props.file}`;

  return (
    <Box>
      <Link href={href} color="teal.500" download>
        <DownloadIcon /> {props.description}
      </Link>
    </Box>
  );
};
